"use client";

import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

export function FAQsSection() {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: "How do I add team members to my account?",
      answer: (
        <div>
          <p className="mb-3">You can invite team members from Settings → Team. Here&apos;s how:</p>
          <ol className="list-decimal list-inside space-y-2 mb-3">
            <li>Navigate to Settings in the left sidebar</li>
            <li>Click on the &quot;Team&quot; tab</li>
            <li>Click the &quot;Invite Member&quot; button</li>
            <li>Enter their email address and select a role (Admin, Agent, or Viewer)</li>
            <li>Click &quot;Send Invitation&quot;</li>
          </ol>
          <p className="text-blue-600 font-medium">
            <a href="#" className="hover:underline">
              → View detailed guide with screenshots
            </a>
          </p>
        </div>
      ),
    },
    {
      question: "What's the difference between AI and Human handover?",
      answer: null,
    },
    {
      question: "How does billing work for multi-store accounts?",
      answer: null,
    },
    {
      question: "Can I use Kustomer Suite with Instagram Direct Messages?",
      answer: null,
    },
    {
      question: "How do I export my conversation data?",
      answer: null,
    },
  ];

  return (
    <div className="flex-1 mt-12">
      {/* Section Header */}
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Frequently Asked Questions</h2>
        <p className="text-sm text-gray-500 mt-1">Quick answers to common questions</p>
      </div>

      {/* FAQ Accordion */}
      <div className="space-y-3">
        {faqs.map((faq, index) => {
          const isExpanded = expandedIndex === index;

          return (
            <div key={index} className="bg-white border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => setExpandedIndex(isExpanded ? null : index)}
                className={`
                  w-full px-6 py-4 flex items-center justify-between text-left
                  ${isExpanded ? "bg-blue-50 border-b border-blue-200" : "hover:bg-gray-50"}
                  transition-colors
                `}
              >
                <h3 className="text-base font-semibold text-gray-900">{faq.question}</h3>
                {isExpanded ? (
                  <ChevronUp className="w-5 h-5 text-gray-600 flex-shrink-0" />
                ) : (
                  <ChevronDown className="w-5 h-5 text-gray-600 flex-shrink-0" />
                )}
              </button>
              {isExpanded && faq.answer && <div className="px-6 py-4 text-sm text-gray-700">{faq.answer}</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
